import { matchPath } from "react-router"

/**
 * The pages where a user can have work in progress that isn't saved: forms, and the quote and policy flows
 * (which run in an embedded app, so the portal can't see whether they have unsaved changes)
 */
const workInProgressPaths = [
  "/clients/create",
  "/clients/edit/:clientId",
  "/brokers/create",
  "/brokers/edit/:id",
  "/opportunity/create",
  "/opportunities/:opportunityId/variants/:variantId/edit",
  "/variant/riskchanges/:opportunityId/:variantId/:opportunityReference",
  "/embargoes/new",
  "/claims/:id/edit",
  "/client-quote/create/:policyholderId?",
  "/create-quote/:productReference",
  "/quick-quote/:productID/:questionSetReferenceID/:quoteID/create",
  "/quick-quote/:id/convert",
  "/policy/adjust/:productRef/:productCover/:id/:userId/:questionSetReferenceID?",
  "/policy/mta/:productId/:policyId"
]

// the embedded quote, checkout and symphony flows, whatever follows
const workInProgressPathPrefixes = ["/opus/", "/symphony/"]

export const isWorkInProgressPath = (pathname: string): boolean =>
  workInProgressPathPrefixes.some((prefix) => pathname.startsWith(prefix)) ||
  workInProgressPaths.some((path) => matchPath(pathname, { path, exact: true }))
